import script from "./AdminDashboardView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminDashboardView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__